import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgIconReject({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      width={16}
      height={16}
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.25a5.75 5.75 0 105.135 3.16.75.75 0 111.338-.678 7.25 7.25 0 11-3.445-3.321.75.75 0 11-.626 1.363A5.726 5.726 0 008 2.25zm3.03 2.72a.75.75 0 010 1.06L9.06 8l1.97 1.97a.75.75 0 01-1.06 1.06L8 9.06l-1.97 1.97a.75.75 0 11-1.06-1.06L6.94 8 4.97 6.03a.75.75 0 011.06-1.06L8 6.94l1.97-1.97a.75.75 0 011.06 0z"
        fill="#666"
      />
    </svg>
  );
}

SvgIconReject.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgIconReject.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgIconReject svgRef={ref} {...props} />);
export default ForwardRef;
